export default __webpack_public_path__ + "static/media/moralisScene.2801caa4.png";